import { render, staticRenderFns } from "./userDashboardNutritionAnamnese.vue?vue&type=template&id=1c5aa747"
import script from "./userDashboardNutritionAnamnese.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionAnamnese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports